import PubSub from "pubsub-js";
import { LitElement, css } from "lit-element";
import { html, render } from "lit-html";
import "@polymer/paper-toast/paper-toast.js";

class KbToast extends LitElement {
  static get styles() {
    return css`
      .positive {
        --paper-toast-background-color: #4caf50;
        --paper-toast-color: white;
      }
      .negative {
        --paper-toast-background-color: #f44336;
        --paper-toast-color: white;
      }
      .info {
        --paper-toast-background-color: blue;
        --paper-toast-color: yellow;
      }
      .warn {
        --paper-toast-background-color: #ffc107;
        --paper-toast-color: black;
      }

      paper-toast {
        font-family: var(--kb-font-family-sans)
      }
    `;
  }

  constructor() {
    super();
    this.type = "";
    this.message = "";
    this.duration = 0;
    this.toast = null;
  }

  connectedCallback() {
    PubSub.subscribe("notifyUser", this._notifyUser.bind(this));
  }

  disconnectedCallback() { }

  _notifyUser(label, params) {
    this.type = params.messageType.toLowerCase();
    this.message = params.message;
    this.duration = params.duration * 1000;
    this._render();
    if (!this.toast) {
      this.toast = this.shadowRoot.querySelector("#toast");
    }
    this.toast.open();
  }

  _render() {
    const template = html`
      <paper-toast
        id="toast"
        class="fit-bottom ${this.type} font"
        duration="${this.duration}"
        text="${this.message}"
      >
      </paper-toast>
    `;
    render(template, this.shadowRoot);
  }
}

customElements.define("kb-toast", KbToast);
